import { useFetcher } from "react-router";
import { useCallback, useEffect, useState } from "react";
import { Pencil, PencilSquare } from "react-bootstrap-icons";
import {
  Button,
  FormControl,
  FormGroup,
  FormLabel,
  Modal,
} from "react-bootstrap";
import { UpdateTask, formikErrors } from "../../ApiClient.js";
import { FormikErrors } from "formik";
import { WithTask } from "./index.js";

export default function RenameTaskButton() {
  const [show, setShow] = useState(false);
  const close = useCallback(() => {
    // eslint-disable-next-line @eslint-react/set-state-in-effect
    setShow(false);
  }, []);
  const open = useCallback(() => setShow(true), []);
  const fetcher = useFetcher();
  const [errors, setErrors] = useState(null as null | FormikErrors<UpdateTask>);

  useEffect(() => {
    if (fetcher.data) {
      if ("error" in fetcher.data) {
        // eslint-disable-next-line @eslint-react/set-state-in-effect
        setErrors(formikErrors(fetcher.data.error));
      } else {
        close();
        // eslint-disable-next-line @eslint-react/set-state-in-effect
        setErrors(null);
      }
    }
  }, [fetcher.data, close]);

  return (
    <>
      <Button size="lg" onClick={open}>
        <PencilSquare /> Rename
      </Button>
      <Modal show={show} onHide={close}>
        <fetcher.Form method="PATCH">
          <Modal.Header closeButton>
            <Modal.Title>
              Rename <WithTask>{({ name }) => `"${name}"`}</WithTask>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup controlId="name">
              <FormLabel>Name</FormLabel>
              <WithTask>
                {({ name }) => (
                  <>
                    <FormControl
                      name="name"
                      type="text"
                      data-1p-ignore
                      defaultValue={name}
                      isInvalid={!!errors?.name}
                    />
                    <FormControl.Feedback type="invalid">
                      {errors?.name}
                    </FormControl.Feedback>
                  </>
                )}
              </WithTask>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={close}>
              Close
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={fetcher.state === "submitting"}
            >
              <Pencil /> Rename
            </Button>
          </Modal.Footer>
        </fetcher.Form>
      </Modal>
    </>
  );
}
